// Define a function to open our custom modal
function openCustomModal(options = {}) {
    // Get the modal template (make sure your snippet contains an element with data-dialog-modal)
    const template = document.querySelector('[data-dialog-modal]');
    if (!template) {
      console.error('No modal template found!');
      return;
    }
  
    // Clone the template content
    const clone = template.content.cloneNode(true);
    const dialog = clone.querySelector('dialog');
    if (!dialog) {
      console.error('Modal template does not contain a <dialog> element!');
      return;
    }
  
    // Update modal header, body, etc.
    const headerEl = dialog.querySelector('[data-modal-header]');
    if (headerEl && options.title) {
      headerEl.textContent = options.title;
    }
  
    const bodyEl = dialog.querySelector('[data-modal-body]');
    if (bodyEl && options.body) {
      bodyEl.innerHTML = options.body;
    }
  
    // Process buttons (an array of objects)
    const actionsContainer = dialog.querySelector('.popup__actions');
    if (actionsContainer) {
      // Clear any existing buttons in the template
      actionsContainer.innerHTML = '';
  
      // Use the provided array or default to a single Close button.
      const buttons = Array.isArray(options.buttons) && options.buttons.length
        ? options.buttons
        : [
            {
              text: 'Close',
              class: 'btn--secondary',
              // Default action: simply close the dialog
              callback: (modalEl) => modalEl.close(),
            },
          ];
  
      // Create each button
      buttons.forEach((btnData) => {
        const btn = document.createElement('button');
        // You can change this to an <a> element if needed
        btn.type = 'button';
        btn.textContent = btnData.text || 'Button';
        if (btnData.class) {
          btn.className = btnData.class;
        }
        // When clicked, execute the callback (if provided) then close by default
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (typeof btnData.callback === 'function') {
            btnData.callback(dialog);
          } else {
            dialog.close();
          }
        });
        actionsContainer.appendChild(btn);
      });
    }
  
    // Append the dialog to the body
    document.body.appendChild(dialog);
  
    // Close the modal when clicking on the backdrop (the dialog itself)
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) {
        dialog.close();
      }
    });
  
    // When the modal closes, remove it from the DOM
    dialog.addEventListener('close', () => {
      dialog.remove();
    });
  
    // Open the dialog using the native method if available
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      // Fallback: just add an open attribute
      dialog.setAttribute('open', '');
    }
  }
  
  // Listen for a custom event so that other JS files can trigger opening the modal.
  document.addEventListener('theme:dialog:open', (e) => {
    // e.detail should include properties: title, body, buttons (array)
    openCustomModal(e.detail);
  });
  
  // Example usage from elsewhere in your code:
  /*
  document.dispatchEvent(
    new CustomEvent('theme:dialog:open', {
      detail: {
        title: 'Confirm your action',
        body: '<p>Are you sure you want to proceed?</p>',
        buttons: [
          {
            text: 'Yes',
            class: 'btn btn--primary btn--solid btn--small',
            callback: (modalEl) => {
              // Do something here...
              console.log('User clicked Yes');
              modalEl.close();
            }
          },
          {
            text: 'No',
            class: 'btn btn--secondary btn--small',
            // For "No", simply close the modal (could also leave callback undefined)
            callback: (modalEl) => modalEl.close()
          }
        ]
      }
    })
  );
  */
  